import { styled } from '@material-ui/core';
import { useIntl } from 'react-intl';

type ChatAssignedByProps = {
  agentAssigned: string;
};

const ChatAssignedBy: React.FC<ChatAssignedByProps> = ({ agentAssigned }) => {
  const { formatMessage } = useIntl();
  return (
    <AssignedIndicator>
      {formatMessage({ id: 'ChatAssign.AssignedBy' })}
      {': '}
      {agentAssigned}
    </AssignedIndicator>
  );
};

const AssignedIndicator = styled('div')(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  fontSize: '0.75rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gridGap: 5,
  borderRadius: 2,
  padding: 4,
  fontWeight: 600,
}));

export default ChatAssignedBy;
